/* sucrase/dist/esm/parser/tokenizer/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.isDeclaration = isDeclaration;
    exports.isNonTopLevelDeclaration = isNonTopLevelDeclaration;
    exports.isTopLevelDeclaration = isTopLevelDeclaration;
    exports.isBlockScopedDeclaration = isBlockScopedDeclaration;
    exports.isFunctionScopedDeclaration = isFunctionScopedDeclaration;
    exports.isObjectShorthandDeclaration = isObjectShorthandDeclaration;
    exports.next = next;
    exports.nextTemplateToken = nextTemplateToken;
    exports.retokenizeSlashAsRegex = retokenizeSlashAsRegex;
    exports.pushTypeContext = pushTypeContext;
    exports.popTypeContext = popTypeContext;
    exports.eat = eat;
    exports.eatTypeToken = eatTypeToken;
    exports.match = match;
    exports.lookaheadType = lookaheadType;
    exports.lookaheadTypeAndKeyword = lookaheadTypeAndKeyword;
    exports.nextTokenStart = nextTokenStart;
    exports.nextTokenStartSince = nextTokenStartSince;
    exports.lookaheadCharCode = lookaheadCharCode;
    exports.nextToken = nextToken;
    exports.skipLineComment = skipLineComment;
    exports.skipSpace = skipSpace;
    exports.finishToken = finishToken;
    exports.rescan_gt = rescan_gt;
    exports.getTokenFromCode = getTokenFromCode;
    exports.skipWord = skipWord;
    const tslib_1 = require("tslib");
    const base_1 = require("540718e523") /* ../traverser/base */;
    const util_1 = require("bc94bbadc1") /* ../traverser/util */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const identifier_1 = require("364148c9f0") /* ../util/identifier */;
    const whitespace_1 = require("2a3176644a") /* ../util/whitespace */;
    const keywords_1 = require("99ff836c64") /* ./keywords */;
    const readWord_1 = tslib_1.__importDefault(require("e6eb78033b") /* ./readWord */);
    const types_1 = require("f0c35cbd76") /* ./types */;
    (function (IdentifierRole) {
        const Access = 0;
        IdentifierRole[IdentifierRole["Access"] = Access] = "Access";
        const ExportAccess = Access + 1;
        IdentifierRole[IdentifierRole["ExportAccess"] = ExportAccess] = "ExportAccess";
        const TopLevelDeclaration = ExportAccess + 1;
        IdentifierRole[IdentifierRole["TopLevelDeclaration"] = TopLevelDeclaration] = "TopLevelDeclaration";
        const FunctionScopedDeclaration = TopLevelDeclaration + 1;
        IdentifierRole[IdentifierRole["FunctionScopedDeclaration"] = FunctionScopedDeclaration] = "FunctionScopedDeclaration";
        const BlockScopedDeclaration = FunctionScopedDeclaration + 1;
        IdentifierRole[IdentifierRole["BlockScopedDeclaration"] = BlockScopedDeclaration] = "BlockScopedDeclaration";
        const ObjectShorthandTopLevelDeclaration = BlockScopedDeclaration + 1;
        IdentifierRole[IdentifierRole["ObjectShorthandTopLevelDeclaration"] = ObjectShorthandTopLevelDeclaration] = "ObjectShorthandTopLevelDeclaration";
        const ObjectShorthandFunctionScopedDeclaration = ObjectShorthandTopLevelDeclaration + 1;
        IdentifierRole[IdentifierRole["ObjectShorthandFunctionScopedDeclaration"] = ObjectShorthandFunctionScopedDeclaration] = "ObjectShorthandFunctionScopedDeclaration";
        const ObjectShorthandBlockScopedDeclaration = ObjectShorthandFunctionScopedDeclaration + 1;
        IdentifierRole[IdentifierRole["ObjectShorthandBlockScopedDeclaration"] = ObjectShorthandBlockScopedDeclaration] = "ObjectShorthandBlockScopedDeclaration";
        const ObjectShorthand = ObjectShorthandBlockScopedDeclaration + 1;
        IdentifierRole[IdentifierRole["ObjectShorthand"] = ObjectShorthand] = "ObjectShorthand";
        // Any identifier bound in an import statement, e.g. both A and b from
        // `import A, * as b from 'A';`
        const ImportDeclaration = ObjectShorthand + 1;
        IdentifierRole[IdentifierRole["ImportDeclaration"] = ImportDeclaration] = "ImportDeclaration";
        const ObjectKey = ImportDeclaration + 1;
        IdentifierRole[IdentifierRole["ObjectKey"] = ObjectKey] = "ObjectKey";
        // The `foo` in `import {foo as bar} from "./abc";`.
        const ImportAccess = ObjectKey + 1;
        IdentifierRole[IdentifierRole["ImportAccess"] = ImportAccess] = "ImportAccess";
    })(exports.IdentifierRole || (exports.IdentifierRole = {}));
    (function (JSXRole) {
        // The element is self-closing or has a body that resolves to empty. We
        // shouldn't emit children at all in this case.
        const NoChildren = 0;
        JSXRole[JSXRole["NoChildren"] = NoChildren] = "NoChildren";
        // The element has a single explicit child, which might still be an arbitrary
        // expression like an array. We should emit that expression as the children.
        const OneChild = NoChildren + 1;
        JSXRole[JSXRole["OneChild"] = OneChild] = "OneChild";
        // The element has at least two explicitly-specified children or has spread
        // children, so child positions are assumed to be "static". We should wrap
        // these children in an array.
        const StaticChildren = OneChild + 1;
        JSXRole[JSXRole["StaticChildren"] = StaticChildren] = "StaticChildren";
        // The element has a prop named "key" after a prop spread, so we should fall
        // back to the createElement function.
        const KeyAfterPropSpread = StaticChildren + 1;
        JSXRole[JSXRole["KeyAfterPropSpread"] = KeyAfterPropSpread] = "KeyAfterPropSpread";
    })(exports.JSXRole || (exports.JSXRole = {}));
    function isDeclaration(token) {
        const role = token.identifierRole;
        return (role === exports.IdentifierRole.TopLevelDeclaration ||
            role === exports.IdentifierRole.FunctionScopedDeclaration ||
            role === exports.IdentifierRole.BlockScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandTopLevelDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandFunctionScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandBlockScopedDeclaration);
    }
    function isNonTopLevelDeclaration(token) {
        const role = token.identifierRole;
        return (role === exports.IdentifierRole.FunctionScopedDeclaration ||
            role === exports.IdentifierRole.BlockScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandFunctionScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandBlockScopedDeclaration);
    }
    function isTopLevelDeclaration(token) {
        const role = token.identifierRole;
        return (role === exports.IdentifierRole.TopLevelDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandTopLevelDeclaration ||
            role === exports.IdentifierRole.ImportDeclaration);
    }
    function isBlockScopedDeclaration(token) {
        const role = token.identifierRole;
        // Treat top-level declarations as block scope since the distinction doesn't matter here.
        return (role === exports.IdentifierRole.TopLevelDeclaration ||
            role === exports.IdentifierRole.BlockScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandTopLevelDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandBlockScopedDeclaration);
    }
    function isFunctionScopedDeclaration(token) {
        const role = token.identifierRole;
        return (role === exports.IdentifierRole.FunctionScopedDeclaration ||
            role === exports.IdentifierRole.ObjectShorthandFunctionScopedDeclaration);
    }
    function isObjectShorthandDeclaration(token) {
        return (token.identifierRole === exports.IdentifierRole.ObjectShorthandTopLevelDeclaration ||
            token.identifierRole === exports.IdentifierRole.ObjectShorthandBlockScopedDeclaration ||
            token.identifierRole === exports.IdentifierRole.ObjectShorthandFunctionScopedDeclaration);
    }
    // Object type used to represent tokens. Note that normally, tokens
    // simply exist as properties on the parser object. This is only
    // used for the onToken callback and the external tokenizer.
    class Token {
        constructor() {
            this.type = base_1.state.type;
            this.contextualKeyword = base_1.state.contextualKeyword;
            this.start = base_1.state.start;
            this.end = base_1.state.end;
            this.scopeDepth = base_1.state.scopeDepth;
            this.isType = base_1.state.isType;
            this.identifierRole = null;
            this.jsxRole = null;
            this.shadowsGlobal = false;
            this.isAsyncOperation = false;
            this.contextId = null;
            this.rhsEndIndex = null;
            this.isExpression = false;
            this.numNullishCoalesceStarts = 0;
            this.numNullishCoalesceEnds = 0;
            this.isOptionalChainStart = false;
            this.isOptionalChainEnd = false;
            this.subscriptStartIndex = null;
            this.nullishStartIndex = null;
        }
    }
    exports.Token = Token;
    // ## Tokenizer
    // Move to the next token
    function next() {
        base_1.state.tokens.push(new Token());
        nextToken();
    }
    // Call instead of next when inside a template, since that needs to be handled differently.
    function nextTemplateToken() {
        base_1.state.tokens.push(new Token());
        base_1.state.start = base_1.state.pos;
        readTmplToken();
    }
    // The tokenizer never parses regexes by default. Instead, the parser is responsible for
    // instructing it to parse a regex when we see a slash at the start of an expression.
    function retokenizeSlashAsRegex() {
        if (base_1.state.type === types_1.TokenType.assign) {
            --base_1.state.pos;
        }
        readRegexp();
    }
    function pushTypeContext(existingTokensInType) {
        for (let i = base_1.state.tokens.length - existingTokensInType; i < base_1.state.tokens.length; i++) {
            base_1.state.tokens[i].isType = true;
        }
        const oldIsType = base_1.state.isType;
        base_1.state.isType = true;
        return oldIsType;
    }
    function popTypeContext(oldIsType) {
        base_1.state.isType = oldIsType;
    }
    function eat(type) {
        if (match(type)) {
            next();
            return true;
        }
        else {
            return false;
        }
    }
    function eatTypeToken(tokenType) {
        const oldIsType = base_1.state.isType;
        base_1.state.isType = true;
        eat(tokenType);
        base_1.state.isType = oldIsType;
    }
    function match(type) {
        return base_1.state.type === type;
    }
    function lookaheadType() {
        const snapshot = base_1.state.snapshot();
        next();
        const type = base_1.state.type;
        base_1.state.restoreFromSnapshot(snapshot);
        return type;
    }
    class TypeAndKeyword {
        constructor(type, contextualKeyword) {
            this.type = type;
            this.contextualKeyword = contextualKeyword;
        }
    }
    exports.TypeAndKeyword = TypeAndKeyword;
    function lookaheadTypeAndKeyword() {
        const snapshot = base_1.state.snapshot();
        next();
        const type = base_1.state.type;
        const contextualKeyword = base_1.state.contextualKeyword;
        base_1.state.restoreFromSnapshot(snapshot);
        return new TypeAndKeyword(type, contextualKeyword);
    }
    function nextTokenStart() {
        return nextTokenStartSince(base_1.state.pos);
    }
    function nextTokenStartSince(pos) {
        whitespace_1.skipWhiteSpace.lastIndex = pos;
        const skip = whitespace_1.skipWhiteSpace.exec(base_1.input);
        return pos + skip[0].length;
    }
    function lookaheadCharCode() {
        return base_1.input.charCodeAt(nextTokenStart());
    }
    // Read a single token, updating the parser object's token-related
    // properties.
    function nextToken() {
        skipSpace();
        base_1.state.start = base_1.state.pos;
        if (base_1.state.pos >= base_1.input.length) {
            const tokens = base_1.state.tokens;
            // We normally run past the end a bit, but if we're way past the end, avoid an infinite loop.
            // Also check the token positions rather than the types since sometimes we rewrite the token
            // type to something else.
            if (tokens.length >= 2 &&
                tokens[tokens.length - 1].start >= base_1.input.length &&
                tokens[tokens.length - 2].start >= base_1.input.length) {
                (0, util_1.unexpected)("Unexpectedly reached the end of input.");
            }
            finishToken(types_1.TokenType.eof);
            return;
        }
        readToken(base_1.input.charCodeAt(base_1.state.pos));
    }
    function readToken(code) {
        // Identifier or keyword. '\uXXXX' sequences are allowed in
        // identifiers, so '\' also dispatches to that.
        if (identifier_1.IS_IDENTIFIER_START[code] ||
            code === charcodes_1.charCodes.backslash ||
            (code === charcodes_1.charCodes.atSign && base_1.input.charCodeAt(base_1.state.pos + 1) === charcodes_1.charCodes.atSign)) {
            (0, readWord_1.default)();
        }
        else {
            getTokenFromCode(code);
        }
    }
    function skipBlockComment() {
        while (base_1.input.charCodeAt(base_1.state.pos) !== charcodes_1.charCodes.asterisk ||
            base_1.input.charCodeAt(base_1.state.pos + 1) !== charcodes_1.charCodes.slash) {
            base_1.state.pos++;
            if (base_1.state.pos > base_1.input.length) {
                (0, util_1.unexpected)("Unterminated comment", base_1.state.pos - 2);
                return;
            }
        }
        base_1.state.pos += 2;
    }
    function skipLineComment(startSkip) {
        let ch = base_1.input.charCodeAt((base_1.state.pos += startSkip));
        if (base_1.state.pos < base_1.input.length) {
            while (ch !== charcodes_1.charCodes.lineFeed &&
                ch !== charcodes_1.charCodes.carriageReturn &&
                ch !== charcodes_1.charCodes.lineSeparator &&
                ch !== charcodes_1.charCodes.paragraphSeparator &&
                ++base_1.state.pos < base_1.input.length) {
                ch = base_1.input.charCodeAt(base_1.state.pos);
            }
        }
    }
    // Called at the start of the parse and after every token. Skips
    // whitespace and comments.
    function skipSpace() {
        while (base_1.state.pos < base_1.input.length) {
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            switch (ch) {
                case charcodes_1.charCodes.carriageReturn:
                    if (base_1.input.charCodeAt(base_1.state.pos + 1) === charcodes_1.charCodes.lineFeed) {
                        ++base_1.state.pos;
                    }
                case charcodes_1.charCodes.lineFeed:
                case charcodes_1.charCodes.lineSeparator:
                case charcodes_1.charCodes.paragraphSeparator:
                    ++base_1.state.pos;
                    break;
                case charcodes_1.charCodes.slash:
                    switch (base_1.input.charCodeAt(base_1.state.pos + 1)) {
                        case charcodes_1.charCodes.asterisk:
                            base_1.state.pos += 2;
                            skipBlockComment();
                            break;
                        case charcodes_1.charCodes.slash:
                            skipLineComment(2);
                            break;
                        default:
                            return;
                    }
                    break;
                default:
                    if (whitespace_1.IS_WHITESPACE[ch]) {
                        ++base_1.state.pos;
                    }
                    else {
                        return;
                    }
            }
        }
    }
    // Called at the end of every token. Sets various fields, and skips the space after the token, so
    // that the next one's `start` will point at the right position.
    function finishToken(type, contextualKeyword = keywords_1.ContextualKeyword.NONE) {
        base_1.state.end = base_1.state.pos;
        base_1.state.type = type;
        base_1.state.contextualKeyword = contextualKeyword;
    }
    // ### Token reading
    // This is the function that is called to fetch the next token. It
    // is somewhat obscure, because it works in character codes rather
    // than characters, and because operator parsing has been inlined
    // into it.
    //
    // All in the name of speed.
    function readToken_dot() {
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar >= charcodes_1.charCodes.digit0 && nextChar <= charcodes_1.charCodes.digit9) {
            readNumber(true);
            return;
        }
        if (nextChar === charcodes_1.charCodes.dot && base_1.input.charCodeAt(base_1.state.pos + 2) === charcodes_1.charCodes.dot) {
            base_1.state.pos += 3;
            finishToken(types_1.TokenType.ellipsis);
        }
        else {
            ++base_1.state.pos;
            finishToken(types_1.TokenType.dot);
        }
    }
    function readToken_slash() {
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            finishOp(types_1.TokenType.assign, 2);
        }
        else {
            finishOp(types_1.TokenType.slash, 1);
        }
    }
    function readToken_mult_modulo(code) {
        // '%*'
        let tokenType = code === charcodes_1.charCodes.asterisk ? types_1.TokenType.star : types_1.TokenType.modulo;
        let width = 1;
        let nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        // Exponentiation operator **
        if (code === charcodes_1.charCodes.asterisk && nextChar === charcodes_1.charCodes.asterisk) {
            width++;
            nextChar = base_1.input.charCodeAt(base_1.state.pos + 2);
            tokenType = types_1.TokenType.exponent;
        }
        // Match *= or %=, disallowing *=> which can be valid in flow.
        if (nextChar === charcodes_1.charCodes.equalsTo &&
            base_1.input.charCodeAt(base_1.state.pos + 2) !== charcodes_1.charCodes.greaterThan) {
            width++;
            tokenType = types_1.TokenType.assign;
        }
        finishOp(tokenType, width);
    }
    function readToken_pipe_amp(code) {
        // '|&'
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === code) {
            if (base_1.input.charCodeAt(base_1.state.pos + 2) === charcodes_1.charCodes.equalsTo) {
                // ||= or &&=
                finishOp(types_1.TokenType.assign, 3);
            }
            else {
                // || or &&
                finishOp(code === charcodes_1.charCodes.verticalBar ? types_1.TokenType.logicalOR : types_1.TokenType.logicalAND, 2);
            }
            return;
        }
        if (code === charcodes_1.charCodes.verticalBar) {
            // '|>'
            if (nextChar === charcodes_1.charCodes.greaterThan) {
                finishOp(types_1.TokenType.pipeline, 2);
                return;
            }
            else if (nextChar === charcodes_1.charCodes.rightCurlyBrace && base_1.isFlowEnabled) {
                // '|}'
                finishOp(types_1.TokenType.braceBarR, 2);
                return;
            }
        }
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            finishOp(types_1.TokenType.assign, 2);
            return;
        }
        finishOp(code === charcodes_1.charCodes.verticalBar ? types_1.TokenType.bitwiseOR : types_1.TokenType.bitwiseAND, 1);
    }
    function readToken_caret() {
        // '^'
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            finishOp(types_1.TokenType.assign, 2);
        }
        else {
            finishOp(types_1.TokenType.bitwiseXOR, 1);
        }
    }
    function readToken_plus_min(code) {
        // '+-'
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === code) {
            // Tentatively call this a prefix operator, but it might be changed to postfix later.
            finishOp(types_1.TokenType.preIncDec, 2);
            return;
        }
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            finishOp(types_1.TokenType.assign, 2);
        }
        else if (code === charcodes_1.charCodes.plusSign) {
            finishOp(types_1.TokenType.plus, 1);
        }
        else {
            finishOp(types_1.TokenType.minus, 1);
        }
    }
    function readToken_lt() {
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === charcodes_1.charCodes.lessThan) {
            if (base_1.input.charCodeAt(base_1.state.pos + 2) === charcodes_1.charCodes.equalsTo) {
                finishOp(types_1.TokenType.assign, 3);
                return;
            }
            // We see <<, but need to be really careful about whether to treat it as a
            // true left-shift or as two < tokens.
            if (base_1.state.isType) {
                // Within a type, << might come up in a snippet like `Array<<T>() => void>`,
                // so treat it as two < tokens. Importantly, this should only override <<
                // rather than other tokens like <= . If we treated <= as < in a type
                // context, then the snippet `a as T <= 1` would incorrectly start parsing
                // a type argument on T. We don't need to worry about `a as T << 1`
                // because TypeScript disallows that syntax.
                finishOp(types_1.TokenType.lessThan, 1);
            }
            else {
                // Outside a type, this might be a true left-shift operator, or it might
                // still be two open-type-arg tokens, such as in `f<<T>() => void>()`. We
                // look at the token while considering the `f`, so we don't yet know that
                // we're in a type context. In this case, we initially tokenize as a
                // left-shift and correct after-the-fact as necessary in
                // tsParseTypeArgumentsWithPossibleBitshift .
                finishOp(types_1.TokenType.bitShiftL, 2);
            }
            return;
        }
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            // <=
            finishOp(types_1.TokenType.relationalOrEqual, 2);
        }
        else {
            finishOp(types_1.TokenType.lessThan, 1);
        }
    }
    function readToken_gt() {
        if (base_1.state.isType) {
            // Avoid right-shift for things like `Array<Array<string>>` and
            // greater-than-or-equal for things like `const a: Array<number>=[];`.
            finishOp(types_1.TokenType.greaterThan, 1);
            return;
        }
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === charcodes_1.charCodes.greaterThan) {
            const size = base_1.input.charCodeAt(base_1.state.pos + 2) === charcodes_1.charCodes.greaterThan ? 3 : 2;
            if (base_1.input.charCodeAt(base_1.state.pos + size) === charcodes_1.charCodes.equalsTo) {
                finishOp(types_1.TokenType.assign, size + 1);
                return;
            }
            finishOp(types_1.TokenType.bitShiftR, size);
            return;
        }
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            // >=
            finishOp(types_1.TokenType.relationalOrEqual, 2);
        }
        else {
            finishOp(types_1.TokenType.greaterThan, 1);
        }
    }
    /**
     * Reinterpret a possible > token when transitioning from a type to a non-type
     * context.
     *
     * This comes up in two situations where >= needs to be treated as one token:
     * - After an `as` expression, like in the code `a as T >= 1`.
     * - In a type argument in an expression context, e.g. `f(a < b, c >= d)`, we
     *   need to see the token as >= so that we get an error and backtrack to
     *   normal expression parsing.
     *
     * Other situations require >= to be seen as two tokens, e.g.
     * `const x: Array<T>=[];`, so it's important to treat > as its own token in
     * typical type parsing situations.
     */
    function rescan_gt() {
        if (base_1.state.type === types_1.TokenType.greaterThan) {
            base_1.state.pos -= 1;
            readToken_gt();
        }
    }
    function readToken_eq_excl(code) {
        // '=!'
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        if (nextChar === charcodes_1.charCodes.equalsTo) {
            finishOp(types_1.TokenType.equality, base_1.input.charCodeAt(base_1.state.pos + 2) === charcodes_1.charCodes.equalsTo ? 3 : 2);
            return;
        }
        if (code === charcodes_1.charCodes.equalsTo && nextChar === charcodes_1.charCodes.greaterThan) {
            // '=>'
            base_1.state.pos += 2;
            finishToken(types_1.TokenType.arrow);
            return;
        }
        finishOp(code === charcodes_1.charCodes.equalsTo ? types_1.TokenType.eq : types_1.TokenType.bang, 1);
    }
    function readToken_question() {
        // '?'
        const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
        const nextChar2 = base_1.input.charCodeAt(base_1.state.pos + 2);
        if (nextChar === charcodes_1.charCodes.questionMark &&
            // In Flow (but not TypeScript), ??string is a valid type that should be
            // tokenized as two individual ? tokens.
            !(base_1.isFlowEnabled && base_1.state.isType)) {
            if (nextChar2 === charcodes_1.charCodes.equalsTo) {
                // '??='
                finishOp(types_1.TokenType.assign, 3);
            }
            else {
                // '??'
                finishOp(types_1.TokenType.nullishCoalescing, 2);
            }
        }
        else if (nextChar === charcodes_1.charCodes.dot &&
            !(nextChar2 >= charcodes_1.charCodes.digit0 && nextChar2 <= charcodes_1.charCodes.digit9)) {
            // '.' not followed by a number
            base_1.state.pos += 2;
            finishToken(types_1.TokenType.questionDot);
        }
        else {
            ++base_1.state.pos;
            finishToken(types_1.TokenType.question);
        }
    }
    function getTokenFromCode(code) {
        switch (code) {
            case charcodes_1.charCodes.numberSign:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.hash);
                return;
            // The interpretation of a dot depends on whether it is followed
            // by a digit or another two dots.
            case charcodes_1.charCodes.dot:
                readToken_dot();
                return;
            // Punctuation tokens.
            case charcodes_1.charCodes.leftParenthesis:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.parenL);
                return;
            case charcodes_1.charCodes.rightParenthesis:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.parenR);
                return;
            case charcodes_1.charCodes.semicolon:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.semi);
                return;
            case charcodes_1.charCodes.comma:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.comma);
                return;
            case charcodes_1.charCodes.leftSquareBracket:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.bracketL);
                return;
            case charcodes_1.charCodes.rightSquareBracket:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.bracketR);
                return;
            case charcodes_1.charCodes.leftCurlyBrace:
                if (base_1.isFlowEnabled && base_1.input.charCodeAt(base_1.state.pos + 1) === charcodes_1.charCodes.verticalBar) {
                    finishOp(types_1.TokenType.braceBarL, 2);
                }
                else {
                    ++base_1.state.pos;
                    finishToken(types_1.TokenType.braceL);
                }
                return;
            case charcodes_1.charCodes.rightCurlyBrace:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.braceR);
                return;
            case charcodes_1.charCodes.colon:
                if (base_1.input.charCodeAt(base_1.state.pos + 1) === charcodes_1.charCodes.colon) {
                    finishOp(types_1.TokenType.doubleColon, 2);
                }
                else {
                    ++base_1.state.pos;
                    finishToken(types_1.TokenType.colon);
                }
                return;
            case charcodes_1.charCodes.questionMark:
                readToken_question();
                return;
            case charcodes_1.charCodes.atSign:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.at);
                return;
            case charcodes_1.charCodes.graveAccent:
                ++base_1.state.pos;
                finishToken(types_1.TokenType.backQuote);
                return;
            case charcodes_1.charCodes.digit0: {
                const nextChar = base_1.input.charCodeAt(base_1.state.pos + 1);
                // '0x', '0X', '0o', '0O', '0b', '0B'
                if (nextChar === charcodes_1.charCodes.lowercaseX ||
                    nextChar === charcodes_1.charCodes.uppercaseX ||
                    nextChar === charcodes_1.charCodes.lowercaseO ||
                    nextChar === charcodes_1.charCodes.uppercaseO ||
                    nextChar === charcodes_1.charCodes.lowercaseB ||
                    nextChar === charcodes_1.charCodes.uppercaseB) {
                    readRadixNumber();
                    return;
                }
            }
            // Anything else beginning with a digit is an integer, octal
            // number, or float.
            case charcodes_1.charCodes.digit1:
            case charcodes_1.charCodes.digit2:
            case charcodes_1.charCodes.digit3:
            case charcodes_1.charCodes.digit4:
            case charcodes_1.charCodes.digit5:
            case charcodes_1.charCodes.digit6:
            case charcodes_1.charCodes.digit7:
            case charcodes_1.charCodes.digit8:
            case charcodes_1.charCodes.digit9:
                readNumber(false);
                return;
            // Quotes produce strings.
            case charcodes_1.charCodes.quotationMark:
            case charcodes_1.charCodes.apostrophe:
                readString(code);
                return;
            // Operators are parsed inline in tiny state machines. '=' (charCodes.equalsTo) is
            // often referred to. `finishOp` simply skips the amount of
            // characters it is given as second argument, and returns a token
            // of the type given by its first argument.
            case charcodes_1.charCodes.slash:
                readToken_slash();
                return;
            case charcodes_1.charCodes.percentSign:
            case charcodes_1.charCodes.asterisk:
                readToken_mult_modulo(code);
                return;
            case charcodes_1.charCodes.verticalBar:
            case charcodes_1.charCodes.ampersand:
                readToken_pipe_amp(code);
                return;
            case charcodes_1.charCodes.caret:
                readToken_caret();
                return;
            case charcodes_1.charCodes.plusSign:
            case charcodes_1.charCodes.dash:
                readToken_plus_min(code);
                return;
            case charcodes_1.charCodes.lessThan:
                readToken_lt();
                return;
            case charcodes_1.charCodes.greaterThan:
                readToken_gt();
                return;
            case charcodes_1.charCodes.equalsTo:
            case charcodes_1.charCodes.exclamationMark:
                readToken_eq_excl(code);
                return;
            case charcodes_1.charCodes.tilde:
                finishOp(types_1.TokenType.tilde, 1);
                return;
            default:
                break;
        }
        (0, util_1.unexpected)(`Unexpected character '${String.fromCharCode(code)}'`, base_1.state.pos);
    }
    function finishOp(type, size) {
        base_1.state.pos += size;
        finishToken(type);
    }
    function readRegexp() {
        const start = base_1.state.pos;
        let escaped = false;
        let inClass = false;
        for (;;) {
            if (base_1.state.pos >= base_1.input.length) {
                (0, util_1.unexpected)("Unterminated regular expression", start);
                return;
            }
            const code = base_1.input.charCodeAt(base_1.state.pos);
            if (escaped) {
                escaped = false;
            }
            else {
                if (code === charcodes_1.charCodes.leftSquareBracket) {
                    inClass = true;
                }
                else if (code === charcodes_1.charCodes.rightSquareBracket && inClass) {
                    inClass = false;
                }
                else if (code === charcodes_1.charCodes.slash && !inClass) {
                    break;
                }
                escaped = code === charcodes_1.charCodes.backslash;
            }
            ++base_1.state.pos;
        }
        ++base_1.state.pos;
        // Need to use `skipWord` because '\uXXXX' sequences are allowed here (don't ask).
        skipWord();
        finishToken(types_1.TokenType.regexp);
    }
    /**
     * Read a decimal integer. Note that this can't be unified with the similar code
     * in readRadixNumber (which also handles hex digits) because "e" needs to be
     * the end of the integer so that we can properly handle scientific notation.
     */
    function readInt() {
        while (true) {
            const code = base_1.input.charCodeAt(base_1.state.pos);
            if ((code >= charcodes_1.charCodes.digit0 && code <= charcodes_1.charCodes.digit9) || code === charcodes_1.charCodes.underscore) {
                base_1.state.pos++;
            }
            else {
                break;
            }
        }
    }
    function readRadixNumber() {
        base_1.state.pos += 2; // 0x
        // Walk to the end of the number, allowing hex digits.
        while (true) {
            const code = base_1.input.charCodeAt(base_1.state.pos);
            if ((code >= charcodes_1.charCodes.digit0 && code <= charcodes_1.charCodes.digit9) ||
                (code >= charcodes_1.charCodes.lowercaseA && code <= charcodes_1.charCodes.lowercaseF) ||
                (code >= charcodes_1.charCodes.uppercaseA && code <= charcodes_1.charCodes.uppercaseF) ||
                code === charcodes_1.charCodes.underscore) {
                base_1.state.pos++;
            }
            else {
                break;
            }
        }
        const nextChar = base_1.input.charCodeAt(base_1.state.pos);
        if (nextChar === charcodes_1.charCodes.lowercaseN) {
            ++base_1.state.pos;
            finishToken(types_1.TokenType.bigint);
        }
        else {
            finishToken(types_1.TokenType.num);
        }
    }
    // Read an integer, octal integer, or floating-point number.
    function readNumber(startsWithDot) {
        let isBigInt = false;
        let isDecimal = false;
        if (!startsWithDot) {
            readInt();
        }
        let nextChar = base_1.input.charCodeAt(base_1.state.pos);
        if (nextChar === charcodes_1.charCodes.dot) {
            ++base_1.state.pos;
            readInt();
            nextChar = base_1.input.charCodeAt(base_1.state.pos);
        }
        if (nextChar === charcodes_1.charCodes.uppercaseE || nextChar === charcodes_1.charCodes.lowercaseE) {
            nextChar = base_1.input.charCodeAt(++base_1.state.pos);
            if (nextChar === charcodes_1.charCodes.plusSign || nextChar === charcodes_1.charCodes.dash) {
                ++base_1.state.pos;
            }
            readInt();
            nextChar = base_1.input.charCodeAt(base_1.state.pos);
        }
        if (nextChar === charcodes_1.charCodes.lowercaseN) {
            ++base_1.state.pos;
            isBigInt = true;
        }
        else if (nextChar === charcodes_1.charCodes.lowercaseM) {
            ++base_1.state.pos;
            isDecimal = true;
        }
        if (isBigInt) {
            finishToken(types_1.TokenType.bigint);
            return;
        }
        if (isDecimal) {
            finishToken(types_1.TokenType.decimal);
            return;
        }
        finishToken(types_1.TokenType.num);
    }
    function readString(quote) {
        base_1.state.pos++;
        for (;;) {
            if (base_1.state.pos >= base_1.input.length) {
                (0, util_1.unexpected)("Unterminated string constant");
                return;
            }
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            if (ch === charcodes_1.charCodes.backslash) {
                base_1.state.pos++;
            }
            else if (ch === quote) {
                break;
            }
            base_1.state.pos++;
        }
        base_1.state.pos++;
        finishToken(types_1.TokenType.string);
    }
    // Reads template string tokens.
    function readTmplToken() {
        for (;;) {
            if (base_1.state.pos >= base_1.input.length) {
                (0, util_1.unexpected)("Unterminated template");
                return;
            }
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            if (ch === charcodes_1.charCodes.graveAccent ||
                (ch === charcodes_1.charCodes.dollarSign && base_1.input.charCodeAt(base_1.state.pos + 1) === charcodes_1.charCodes.leftCurlyBrace)) {
                if (base_1.state.pos === base_1.state.start && match(types_1.TokenType.template)) {
                    if (ch === charcodes_1.charCodes.dollarSign) {
                        base_1.state.pos += 2;
                        finishToken(types_1.TokenType.dollarBraceL);
                        return;
                    }
                    else {
                        ++base_1.state.pos;
                        finishToken(types_1.TokenType.backQuote);
                        return;
                    }
                }
                finishToken(types_1.TokenType.template);
                return;
            }
            if (ch === charcodes_1.charCodes.backslash) {
                base_1.state.pos++;
            }
            base_1.state.pos++;
        }
    }
    // Skip to the end of the current word. Note that this is the same as the snippet at the end of
    // readWord, but calling skipWord from readWord seems to slightly hurt performance from some rough
    // measurements.
    function skipWord() {
        while (base_1.state.pos < base_1.input.length) {
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            if (identifier_1.IS_IDENTIFIER_CHAR[ch]) {
                base_1.state.pos++;
            }
            else if (ch === charcodes_1.charCodes.backslash) {
                // \u
                base_1.state.pos += 2;
                if (base_1.input.charCodeAt(base_1.state.pos) === charcodes_1.charCodes.leftCurlyBrace) {
                    while (base_1.state.pos < base_1.input.length &&
                        base_1.input.charCodeAt(base_1.state.pos) !== charcodes_1.charCodes.rightCurlyBrace) {
                        base_1.state.pos++;
                    }
                    base_1.state.pos++;
                }
            }
            else {
                break;
            }
        }
    }
}
